import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Wand2 } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "../ui/alert-dialog";

export const ReinterpretPanel = ({ count, onDone }) => {
  const [job, setJob] = useState(null);

  useEffect(() => {
    if (!job?.running) return undefined;
    const t = setInterval(async () => {
      const { data } = await api.get("/admin/regenerate");
      setJob(data);
      if (!data.running) { toast.success(`Rewrote ${data.done} memories${data.failed ? ` (${data.failed} used the fallback)` : ""}. Audio is rendering in the background.`); onDone(); }
    }, 1500);
    return () => clearInterval(t);
  }, [job?.running, onDone]);

  const start = async () => {
    try { setJob((await api.post("/admin/regenerate")).data); } catch (err) { toast.error(errMsg(err, "Could not start")); }
  };

  const pct = job?.total ? Math.round((job.done / job.total) * 100) : 0;
  return (
    <div data-testid="reinterpret-panel" className="flex flex-wrap items-center gap-3">
      <AlertDialog>
        <AlertDialogTrigger asChild>
          <button data-testid="reinterpret-button" disabled={count === 0 || job?.running} className="lab-btn-ghost"><Wand2 size={16} /> {job?.running ? `Rewriting ${job.done}/${job.total}...` : "Rewrite all memories from the case file"}</button>
        </AlertDialogTrigger>
        <AlertDialogContent className="lab-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle className="font-display uppercase tracking-widest">Rewrite all {count} memories?</AlertDialogTitle>
            <AlertDialogDescription className="text-slate-400">The AI writes a new memory, clue, translation and sound bed for every object using the current case file. Tags, hive words, sounds, icons and voices are kept. Voice and sound audio are re-rendered afterwards.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel className="lab-btn-ghost">Cancel</AlertDialogCancel>
            <AlertDialogAction data-testid="reinterpret-confirm" className="lab-btn-primary" onClick={start}>Rewrite memories</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
      {job?.running && (
        <div data-testid="reinterpret-progress" className="h-2 w-40 bg-slate-800"><div className="h-full meter-on transition-[width]" style={{ width: `${pct}%` }} /></div>
      )}
    </div>
  );
};
